import { createSelector } from '@ngrx/store';

export const getAppState$ = (state: any) => state.app;

export const getSelectedYear$ = createSelector(getAppState$, state => state.selected_year);
